/**
 * Tema visual inspirado no MSN Messenger (Windows XP).
 */
export const MSN = {
  // Gradientes e barras
  titleBar: 'linear-gradient(180deg, #5b9bd5 0%, #7eb5e8 50%, #b8d4f0 100%)',
  titleBarText: '#1a365d',
  windowBg: '#ffffff',
  contentBg: '#f8fafc',
  listBg: '#ffffff',
  inputBg: '#ffffff',

  // Status (cor da borda do avatar = status da pessoa)
  online: '#22c55e',
  busy: '#ef4444',
  away: '#f59e0b',
  offline: '#94a3b8',
  /** Mapa status -> cor para molduras de foto (borda e cantos arredondados) */
  statusBorder: {
    available: '#22c55e',
    busy: '#ef4444',
    away: '#f59e0b',
    offline: '#94a3b8',
  },

  // Texto
  textPrimary: '#1e293b',
  textSecondary: '#64748b',
  textMuted: '#94a3b8',

  // Bordas
  border: '#d1d5db',
  borderLight: '#e2e8f0',

  // Banners
  infoBannerYellow: '#fffacd',
  infoBannerYellowBorder: '#e6d98a',
  infoBannerBlue: '#e3f2fd',
  infoBannerBlueBorder: '#90caf9',

  // Botões
  sendButton: 'linear-gradient(180deg, #7eb5e8 0%, #5b9bd5 100%)',
  sendButtonHover: 'linear-gradient(180deg, #90c2f0 0%, #6ba3e0 100%)',
  buttonBg: '#5b9bd5',
  buttonHover: '#4a90d9',

  // Bolhas de mensagem
  bubbleSent: '#dbeafe',
  bubbleSentBorder: '#93c5fd',
  bubbleReceived: '#f1f5f9',
  bubbleReceivedBorder: '#cbd5e1',

  // Hover
  hoverBg: 'rgba(91, 155, 213, 0.12)',
};
